import React, {useState} from 'react';
import * as CoreFns from '../utilities/CoreFns';
import * as ResponsiveFns from '../utilities/ResponsiveFns';
import NormalBtn from './NormalBtn';
import OwnColor from '../Editor/OwnColor';
import TableGrid from './TableGrid';
import Form2 from '../Tabs/Form2';
import NormalIcon from './NormalIcon';

function App(props) {

  var objPath = props.objPath;
  var organicChanges = props.organicChanges;
  var currentList = props.currentList;
  var userNos = props.userNos;
  var mostRecentColor = props.mostRecentColor;
  var setMostRecentColor = props.setMostRecentColor;
  var columnWidthReal = props.columnWidth;
  var addToExtraScreen = props.addToExtraScreen;
  var error = props.error;
  var leftColRefs = props.leftColRefs;
  var setLeftColRefs = props.setLeftColRefs;

  var dataPath = objPath.concat(['d']);
  var existingDataSources = CoreFns.goDownPath(currentList, dataPath);
  var dataKeys = CoreFns.sortedKeyList(existingDataSources);

  var initialShowWhat = '';
  if (dataKeys.length > 0){
    initialShowWhat = dataKeys[0];
  }

  const [showWhichData, setShowWhichData] = useState(initialShowWhat);
  const [showWhat, setShowWhat] = useState(0);

  var sourceType = {t:'ListType', c:{t:'Object', c:[{t: 'UInteger', sp:'dateTime', keyOnce:'a', n: 'date'}, {t: 'Decimal', keyOnce:'b', n: 'value'}]}};

  function addData(e){

    var uuid = CoreFns.uuidScoped(userNos, currentList, dataPath, []);  
    var ord = ResponsiveFns.getNextOrd(currentList, dataPath);

    var s = {ord:{t:'int',v:ord}, cap:{t:'raw',v:'Bitcoin'}, strokeColor:{t: 'raw', v: "rgb(0, 0, 0)"}, dS:{"o":{"t":"f","i":104,"v":[{"t":"coin","v":"bitcoin"},{"t":"curr","v":"usd"},{"t":"ui","v":"30"}]},"r":sourceType,"t":"formula","x":[{"t":"f","v":104},{"t":"g","v":"c0_4ccf773a"},{"t":"g","v":"c0_e90c4ea6"},{"t":"g","v":"c0_ce6ddab0"}],"y":{"c0_4ccf773a":{"x":[{"t":"coin","v":"bitcoin"}]},"c0_e90c4ea6":{"x":[{"t":"curr","v":"usd"}]},"c0_ce6ddab0":{"x":[{"t":"ui","v":"30"}]}}}};

    var _na = CoreFns.simplName(uuid);
    var n = {_na, s};
    var pp = [{t:'w',w:dataPath.concat([uuid]),n}];
    organicChanges(pp);
    setShowWhichData(uuid);
  }

  var but = [{t:'Source',i:0,ic:'fa6-solid:oil-well'}, {t:'Stroke',i:1,ic:'clarity:color-palette-solid'}, {t:'Settings',i:2,ic:'bytesize:settings'}];
  function clickShowWhat(x){
    setShowWhat(x.i);
  }

  function changeName(aKey, origName){
    return function(e){
      var p = window.prompt('What would you like the new name to be?', origName);
      if (p !== undefined){
        p = p.trim();
        if (p){
          var changes = [{t:'w', w:dataPath.concat([aKey, '_na']), n:p}];
          organicChanges(changes);
        }else{
          window.alert('Blank names not allowed');
        }
      }
    }
  }


  function clickShowData(whichData){
    return function(e){
      setShowWhichData(whichData);
      setShowWhat(0);
    }
  }

  function deleteData(aKey){
    return function(e){
      var changes = [{t:'r',w:dataPath,i:aKey}];
      organicChanges(changes);
    }
  }

  var existingPieces = dataKeys.map((aKey, index)=>{
    var thisData = existingDataSources[aKey];
    var stylePath = dataPath.concat([aKey,'s']);
    if (aKey === showWhichData){  
      var currentScreenStyle = thisData.s;
      var showPiece;

      function submitGeneric(ans, whatDrop){
        var changes = [];
        if (ans.v === false){
          changes = [{t:'r',w:stylePath,i:whatDrop}]
        }else{
          changes = [{t:'w',w:stylePath.concat([whatDrop]),n:ans}];
        }
        organicChanges(changes);
      }

      if (showWhat === 0){

        var questions1 = [{q:'Data Source', t:sourceType, i:'dS', f:1, c:[]}];

    //
        var co = <Form2 addToExtraScreen={addToExtraScreen} organicChanges={organicChanges} questions={questions1} header={stylePath} userNos={userNos} currentList={currentList} error={error} justTakeFirstQuestion={true} leftColRefs={leftColRefs} setLeftColRefs={setLeftColRefs}/>

        showPiece = <center>{co}</center>
//
      }else if (showWhat === 1){
        var currentColor;

        if (currentScreenStyle){
          currentColor = currentScreenStyle.strokeColor;
        }

        function changeColor(e){
            submitGeneric({t:'raw', v:e}, 'strokeColor');
        }

        var e1 = isErrorHere(error, stylePath.concat(['strokeColor']));

        //need error checks;

        showPiece = <OwnColor currentList={currentList} submitColor={changeColor} currentStyle={currentColor} allowFormula={false} e={e1} width={columnWidthReal} mostRecentColor={mostRecentColor} setMostRecentColor={setMostRecentColor} colorType='strokeColor' logPath={stylePath} organicChanges={organicChanges}/>    

      }else if (showWhat === 2){

        var questions = [{q:'Caption', t:{t:'Text String'}, i:'cap', f:1, h:'Title for the Data Series'}];

    //
        showPiece = <Form2 addToExtraScreen={addToExtraScreen} organicChanges={organicChanges} questions={questions} header={stylePath} userNos={userNos} currentList={currentList} error={error} justTakeFirstQuestion={true} leftColRefs={leftColRefs} setLeftColRefs={setLeftColRefs}/>
      }

      return <div style={{padding:'5px',backgroundColor:'#EEE',borderRadius:'5px'}}>

        <table><tbody><tr><td style={{width:'100%'}}>
      Data <span onClick={changeName(aKey, thisData._na)} style={{cursor:'pointer'}}><u>{thisData._na}</u></span>
      </td><td><NormalIcon icon='fe:trash' title='Delete' height='20px' onClick = {deleteData(aKey)} /></td></tr></tbody></table>
      <br/><TableGrid options={but} currentAnswer={showWhat} onClick={clickShowWhat} /><br/>{showPiece}</div>
//
    }else{
      return <div onClick={clickShowData(aKey)} className='selectText' style={{padding:'5px'}}><u>Data {thisData._na}</u></div>
    }
  })
//
  return (<td>{existingPieces}
    <br/>
    <NormalBtn backScreen={true} onClick={addData} title='Add Source' />
    </td>)

}
//
function isErrorHere(error, path){
  if (error && (error.loc.join(' ').indexOf(path).join(' ') === 0)){
    return true;
  }
  return false;
}

//
export default App;
